import { Funnel } from 'lucide-react';
import type { Ref } from 'react';

type FilterToggleButtonProps = {
  readonly label: string;
  readonly activeCount: number;
  readonly isPanelOpen: boolean;
  readonly onClick: () => void;
  readonly buttonTestId?: string;
  readonly countTestId?: string;
  readonly ref?: Ref<HTMLButtonElement>;
};

export function FilterToggleButton({
  label,
  activeCount,
  isPanelOpen,
  onClick,
  buttonTestId,
  countTestId,
  ref,
}: FilterToggleButtonProps) {
  return (
    <button
      ref={ref}
      type="button"
      className="flex items-center gap-2 px-4 py-2 text-sm font-medium border rounded-lg transition-colors bg-prim/5 border-prim text-prim cursor-pointer"
      aria-expanded={isPanelOpen}
      data-testid={buttonTestId}
      onClick={onClick}
    >
      <Funnel size={16} />
      <span>{label}</span>
      {activeCount > 0 && (
        <span
          data-testid={countTestId}
          className="flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-semibold rounded-full bg-prim text-white"
        >
          {activeCount}
        </span>
      )}
    </button>
  );
}
